"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../api/ApplicationContext");
var _SecurityContextHolder = require("../api/SecurityContextHolder");
var _MenuHistoryHolder = require("../api/MenuHistoryHolder");
var _Menu = _interopRequireDefault(require("../api/Menu"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import PropTypes from 'prop-types';

const SiteBreadcrumb = () => {
  const showHierarchyBreadcrumb = _ApplicationContext.ApplicationContext.getSiteDefinition().breadcrumb === 'hierarchy';
  const showHistoryBreadcrumb = _ApplicationContext.ApplicationContext.getSiteDefinition().breadcrumb === 'history';
  const showBreadcrumb = showHierarchyBreadcrumb || showHistoryBreadcrumb;
  const [items, setItems] = (0, _react.useState)([]);
  const getMenuItemFromHistory = id => {
    const menuHistory = _MenuHistoryHolder.MenuHistoryHolder.getHistory();
    if (menuHistory && menuHistory.length > 0) {
      for (let i = 0; i < menuHistory.length; i++) {
        if (id === menuHistory[i].id) {
          return menuHistory[i];
        }
      }
    }
    return null;
  };
  const getLatestMenuItemFromHistory = () => {
    const menuHistory = _MenuHistoryHolder.MenuHistoryHolder.getHistory();
    if (menuHistory && menuHistory.length > 0) {
      return menuHistory[menuHistory.length - 1].menuItem;
    }
    return null;
  };
  const getItems = menuItemArg => {
    let computedItems = [];
    if (showBreadcrumb) {
      const menuPath = [];
      const tempMenuItem = menuItemArg || getLatestMenuItemFromHistory();
      if (showHierarchyBreadcrumb && tempMenuItem) {
        let tempMenuPath = [];
        if (_SecurityContextHolder.SecurityContextHolder.isAuthenticated()) {
          tempMenuPath = _SecurityContextHolder.SecurityContextHolder.getCurrentContext().menu.getMenuPath(tempMenuItem.id);
        } else {
          const menuItems = {
            menuItems: _ApplicationContext.ApplicationContext.getSiteDefinition()?.public?.siteMenu
          };
          const publicMenuItems = _Menu.default.from(menuItems);
          tempMenuPath = publicMenuItems.getMenuPath(tempMenuItem.id);
          // console.log(tempMenuPath);
        }
        tempMenuPath.forEach(item => {
          const historyItem = getMenuItemFromHistory(item.id);
          let url = historyItem?.href || item.path;
          url = url.indexOf(':') === -1 ? url : '#';
          const priorItem = menuPath.length > 0 ? menuPath[menuPath.length - 1] : null;
          if (priorItem) {
            const priorTitle = priorItem.title || priorItem.name;
            const priorHref = priorItem.href;
            const itemTitle = item.title || item.name;
            if (itemTitle !== priorTitle || priorHref !== url) {
              menuPath.push({
                ...item,
                href: url
              });
            }
          } else {
            menuPath.push({
              ...item,
              href: url
            });
          }
        });
      }
      if (showHistoryBreadcrumb) {
        const menuHistory = _MenuHistoryHolder.MenuHistoryHolder.getHistory();
        if (menuHistory && menuHistory.length > 0) {
          const historiesDesc = menuHistory.reverse();
          const maxCrumbs = 5;
          let crumbCount = 0;
          historiesDesc.forEach(item => {
            if (crumbCount < maxCrumbs) {
              menuPath.push({
                ...item.menuItem,
                href: item.href
              });
              crumbCount++;
            }
          });
        }
        menuPath.reverse();
      }
      const filteredMenuPath = menuPath.filter(mItem => mItem.title || mItem.name);
      computedItems = filteredMenuPath.map(mItem => ({
        label: mItem.title || mItem.name,
        url: mItem.href
      }));
      // console.log(items);
    }
    return computedItems;
  };
  const onMessageReceived = (0, _react.useCallback)(event => {
    if (event.origin !== window.location.origin) {
      return;
    }
    try {
      if (typeof event.data === 'object') {
        const {
          data
        } = event;
        if (data?.src === 'core' && data?.status === 'EVENT' && data?.message === _MenuHistoryHolder.MenuHistoryHolder.MENU_HISTORY_ADD_MESSAGE_KEY) {
          setItems(getItems());
        }
      }
    } catch {
      //  disregard items that error out
    }
  }, []);
  (0, _react.useEffect)(() => {
    window.addEventListener('message', onMessageReceived);
    return () => window.removeEventListener('message', onMessageReceived);
  }, [onMessageReceived]);
  if (showBreadcrumb && items && items.length > 1) {
    return /*#__PURE__*/_react.default.createElement(_core.ErrorBoundry, null, /*#__PURE__*/_react.default.createElement(_core.Breadcrumb, {
      items: items
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
var _default = exports.default = SiteBreadcrumb;
//# sourceMappingURL=SiteBreadcrumb.js.map